import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbCheckbox from "../../styling/bbCheckbox";


class Activities extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="columns">
                    <div className="column" style={{display: "flex", flexWrap: "wrap"}}>
                        <React.Fragment>
                            <BbCheckbox label={"NACE"} value={this.props.formik.values.activities.nace} id="nace-act" onChange={c => this.props.formik.setFieldValue('activities.nace', c)} />
                            <BbCheckbox label={this.props.translate("Search.Marketing.Scope")} value={this.props.formik.values.activities.activities} id="act" onChange={c => this.props.formik.setFieldValue('activities.activities', c)} />
                            <BbCheckbox label={this.props.translate("Search.Marketing.Trades")} value={this.props.formik.values.activities.trades} id="trades" onChange={c => this.props.formik.setFieldValue('activities.trades', c)} />

                        </React.Fragment>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(connectFormik(Activities))


